import React, { useState } from 'react';

import { clsx } from '../../utils/utils';
import * as styles from './ScrollingItems.module.scss';

export type ScrollingItemsProps = {
  className?: string;
  elementsClassName?: string;
  animationDirection?: 'left' | 'right';
  children: React.ReactNode;
  animationDuration: number;
  pauseOnHover?: boolean;
  stopAnimationOnLargerScreens?: boolean;
};

const ScrollingItems = ({
  children,
  pauseOnHover,
  animationDirection,
  animationDuration,
  stopAnimationOnLargerScreens,
  className,
  elementsClassName,
}: ScrollingItemsProps): React.ReactElement => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className={clsx(styles.elementsWrapper, className)}>
      <div
        className={clsx(
          styles.elementsContainer,
          animationDirection === 'left' && styles.animationToLeftSide,
          stopAnimationOnLargerScreens && styles.stopOnLargerScreens,
          elementsClassName,
        )}
        style={{
          animationDuration: `${animationDuration}s`,
          animationPlayState: pauseOnHover && isHovered ? 'paused' : 'running',
        }}
        onMouseEnter={() => {
          setIsHovered(true);
        }}
        onMouseLeave={() => {
          setIsHovered(false);
        }}
      >
        {children}
        <div className={styles.elementsContainerCopy}>{children}</div>
      </div>
    </div>
  );
};

export default ScrollingItems;
